import PageHero from "../components/PageHero";

const VALUES = [
  {
    icon: "ri-home-4-line",
    title: "Design First",
    desc: "Every villa is architecturally designed to blend with nature while maximizing guest comfort, visual appeal and rental demand.",
  },
  {
    icon: "ri-leaf-line",
    title: "Sustainable by Design",
    desc: "Eco-friendly materials, energy-efficient systems and responsible construction that respects the land and attracts modern travellers.",
  },
  {
    icon: "ri-hand-coin-line",
    title: "Investor-Aligned",
    desc: "Our success is tied to your returns. Transparent pricing, clear revenue models and end-to-end support from day one.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Built to Last",
    desc: "Engineered for durability with low maintenance costs, our villas are designed to deliver value for 25+ years.",
  },
];

const TIMELINE = [
  { year: "2010", text: "Govianu Group founded with a focus on land acquisition and development in South India." },
  { year: "2017", text: "Expanded into hospitality and tourism developments across leisure destinations." },
  { year: "2022", text: "Began R&D on modular A-frame villa systems for scalable hospitality construction." },
  { year: "2025", text: "Nomad Livings launched — bringing premium modular A-frame villas to investors and travellers across India." },
];

export default function About() {
  return (
    <div className="w-full">
      <PageHero
        eyebrow="About Us"
        title={
          <>
            Backed by 15+ Years of <span className="italic text-accent-300">Real Estate Expertise</span>
          </>
        }
        subtitle="Nomad Livings is the hospitality investment arm of the Govianu Group — combining real-world development experience with modular A-frame villa design."
      />

      <section className="w-full py-12 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-8 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-primary-600">
              <i className="ri-building-2-line"></i> Our Story
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mt-3 leading-tight">
              We Build Villas That <span className="italic text-primary-700">Inspire & Earn</span>
            </h2>
            <p className="text-foreground-600 mt-5 leading-relaxed">
              India&apos;s hospitality and experiential travel markets are booming — yet there is a
              shortage of thoughtfully designed, nature-first accommodations. We built Nomad Livings
              to fill that gap. By combining the Govianu Group&apos;s 15+ years of real estate and
              hospitality experience with a precision modular A-frame system, we create premium
              villas that guests love and investors trust.
            </p>
            <p className="text-foreground-600 mt-4 leading-relaxed">
              From the misty hills of Coorg to the beaches of Goa, every Nomad Livings villa is
              designed for multiple revenue streams — staycations, Airbnb rentals, boutique
              resorts, eco retreats and holiday homes. One architectural system. Five smart
              configurations. Endless possibilities.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {VALUES.map((v) => (
              <div
                key={v.title}
                className="rounded-2xl bg-background-100 border border-background-200 p-6 hover:border-primary-300 transition-colors"
              >
                <span className="flex items-center justify-center w-11 h-11 rounded-xl bg-primary-100 text-primary-700">
                  <i className={`${v.icon} text-xl`}></i>
                </span>
                <h3 className="font-heading text-lg text-foreground-950 mt-4">{v.title}</h3>
                <p className="text-sm text-foreground-600 mt-2 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full py-12 md:py-16 bg-background-100">
        <div className="w-full px-4 md:px-8 max-w-5xl mx-auto">
          <div className="text-center">
            <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-primary-600">
              <i className="ri-time-line"></i> Our Journey
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mt-3">Milestones</h2>
          </div>
          <div className="mt-10 space-y-0">
            {TIMELINE.map((t, i) => (
              <div key={t.year} className="relative flex gap-5 pb-8">
                {i !== TIMELINE.length - 1 && (
                  <span className="absolute left-[23px] top-12 bottom-0 w-px bg-background-300"></span>
                )}
                <span className="flex items-center justify-center w-12 h-12 rounded-full bg-primary-600 text-background-50 shrink-0 font-heading text-sm font-bold">
                  {t.year}
                </span>
                <div className="pt-2.5">
                  <p className="text-sm text-foreground-700 leading-relaxed">{t.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}